// File: frontend/src/pages/SuperAdmin/components/SubscriptionManagement/index.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
// import SubscriptionCreate from './SubscriptionCreate';
import SubscriptionCreate from './SubscriptionList'; // UPDATE THIS
import SubscriptionList from './SubscriptionList';
import SubscriptionDetail from './SubscriptionDetail';
import SubscriptionTiers from './SubscriptionTiers';
import styles from './SubscriptionManagement.module.css';

const SubscriptionManagement = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [view, setView] = useState('list');
  const [subscriptionId, setSubscriptionId] = useState(null);
  
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/super-admin-panel/subscriptions') {
      setView('list');
    } else if (path === '/super-admin-panel/subscriptions/tiers') {
      setView('tiers');
    } else if (path === '/super-admin-panel/subscriptions/create') {
      setView('create');
    } else if (path.match(/\/super-admin-panel\/subscriptions\/[^/]+$/)) {
      const id = path.split('/').pop();
      setSubscriptionId(id);
      setView('detail');
    }
  }, [location.pathname]);
  
  const handleViewSubscription = (id) => {
    navigate(`/super-admin-panel/subscriptions/${id}`);
  };
  
  const handleViewTiers = () => {
    navigate('/super-admin-panel/subscriptions/tiers');
  };
  
  const handleCreateSubscription = () => {
    navigate('/super-admin-panel/subscriptions/create');
  };
  
  const handleBackToList = () => {
    navigate('/super-admin-panel/subscriptions');
  };
  
  // Render the appropriate view
  const renderView = () => {
    switch (view) {
      case 'detail':
        return (
          <SubscriptionDetail 
            subscriptionId={subscriptionId} 
            onBack={handleBackToList}
          />
        );
      case 'tiers':
        return (
          <SubscriptionTiers 
            onBack={handleBackToList}
          />
        );
      case 'create':
        return (
          <SubscriptionCreate 
            onBack={handleBackToList}
            onSuccess={(id) => navigate(`/super-admin-panel/subscriptions/${id}`)}
          />
        );
      default:
        return (
          <SubscriptionList 
            onViewDetail={handleViewSubscription}
            onViewTiers={handleViewTiers}
            onCreateSubscription={handleCreateSubscription}
          />
        );
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        {view === 'list' && t('subscription_management')}
        {view === 'detail' && t('subscription_details')}
        {view === 'tiers' && t('subscription_tiers')}
        {view === 'create' && t('create_subscription')}
      </h1>
      
      {renderView()}
    </div>
  );
};

export default SubscriptionManagement;